// extracted by mini-css-extract-plugin
export default {"container":"style_container__uvhjB","card":"style_card__qe4Wv","row":"style_row__O8-sP","btnsRow":"style_btnsRow__ns6Mt"};